import styled, { css, keyframes } from 'styled-components';
import { playTransitionCubicEaseInOut, svgIconPlay, svgIconPlayOpaque } from './design-tokens';
import { regularOutline } from './typography/helpers';
import { device } from './breakpoints';

export const ClearFix = css`
    &:after {
        content: '';
        clear: both;
        display: table;
    }
`;

export const PlayFocus = css`
    outline: none;

    &:focus {
        ${regularOutline()}
    }

    &:focus-visible {
        ${regularOutline()}
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }
`;

export const VisuallyHidden = css`
    position: absolute !important; /* stylelint-disable-line declaration-no-important */
    overflow: hidden;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    outline: 0;
`;

export const VisuallyHiddenStyle = styled.p`
    ${VisuallyHidden}
`;

export const placeholderColor = (color) => css`
    &::-webkit-input-placeholder {
        color: ${color};
    }
    &::-moz-placeholder {
        color: ${color};
    }
    &:-moz-placeholder {
        color: ${color};
    }
    &:-ms-input-placeholder {
        color: ${color};
    }
`;

const playIconAnimation = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

export const getPlayIcon = (touchevents) => {
    if (touchevents) {
        return css`
            &:after {
                transform-origin: center;
                position: absolute;
                bottom: 4px;
                left: 4px;
                background-size: 60px 60px;
                background-size: contain;
                content: '';
                width: 20px;
                height: 20px;
                display: block;
                background-image: url('data:image/svg+xml;base64,${svgIconPlayOpaque}');
                background-repeat: no-repeat;
                background-position: center;

                ${(props) =>
                    props.onlyAvailableInSweden &&
                    css`
                        .no-sweden & {
                            display: none;
                        }
                    `};
            }
            
            @media ${device.GteSmall} {
                &:after {
                    width: 30px;
                    height: 30px;
                    bottom: 6px;
                    left: 6px;
                }
            }
            `;
    }

    return css`
        &:after {
        transform-origin: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        content: '';
        width: 40px;
        height: 40px;
        display: block;
        background-image: url('data:image/svg+xml;base64,${svgIconPlay}');
        background-repeat: no-repeat;
        background-position: center;
        opacity: 0.8;
        border-radius: 50%;

        @media ${device.GteSmall} {
            height: 50px;
            width: 50px;
        }

        &:hover {
            opacity: 1;
        }

        animation: ${playIconAnimation} 80ms
            ${playTransitionCubicEaseInOut};

        ${(props) =>
            props.onlyAvailableInSweden &&
            css`
                .no-sweden & {
                    display: none;
                }
            `};
    }
    `;
};

export const playIconOverlay = css`
    &:after {
        transform-origin: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        content: '';
        width: 60px;
        height: 60px;
        display: block;
        background-image: url('data:image/svg+xml;base64,${svgIconPlay}');
        background-repeat: no-repeat;
        background-position: center;

        animation: ${playIconAnimation} 80ms
            ${playTransitionCubicEaseInOut};

        ${(props) =>
            props.onlyAvailableInSweden &&
            css`
                .no-sweden & {
                    display: none;
                }
            `};
    }
`;
